"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSession = void 0;
function isSession(item) {
    return (item !== undefined &&
        item !== null &&
        Object.prototype.hasOwnProperty.call(item, 'id') &&
        Object.prototype.hasOwnProperty.call(item, 'startedAt') &&
        Object.prototype.hasOwnProperty.call(item, 'updatedAt') &&
        typeof item.id === 'string' &&
        typeof item.startedAt === 'number' &&
        typeof item.updatedAt === 'number');
}
exports.isSession = isSession;
//# sourceMappingURL=isSession.js.map